import { stringify } from 'hub-http/helpers/params';
import { buildSearchStringWithCurrentSourceFields } from 'automation-ui-canvas/utils/routingUtils';
export function buildSearchStringForActionSetRoutes(flow, location, queryParams) {
  return flow.isActionSet() ? buildSearchStringWithCurrentSourceFields({
    location,
    queryParams
  }) : stringify(queryParams);
}